export const LOGO_SRC = "/svgs/jarvis-logo.svg";
export const LOGO_TAGLINE = "Investing powered by ";
export const LOGO_TAGLINE_ACCENT = "AI";
export const FINAL_CTA_LABEL = "Start Investing Now";
export const ACCENT_COLOR = "#0000FF";
export const INACTIVE_DOT_COLOR = "#C3C8E0";
export const SWIPE_THRESHOLD_PX = 40;
export const SNAP_DURATION_MS = 320;
export const EDGE_DRAG_RESISTANCE = 0.35;
export const SNAP_EASING = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";

export const LAYOUT = {
  heroMinHeight: "clamp(180px, 28vh, 260px)",
  featureBarHeight: 100,
  ctaSlotHeight: 56,
};

export const SLIDE_LAYOUT_PROFILES = {
  featureBar: {
    heroMinHeight: "clamp(200px, 30vh, 280px)",
    heroFlexGrow: true,
    bodyScrollable: false,
  },
  dataGrid: {
    heroMinHeight: "clamp(170px, 26vh, 230px)",
    heroFlexGrow: true,
    bodyScrollable: false,
  },
  oneAi: {
    heroMinHeight: "clamp(140px, 22vh, 220px)",
    // heroMaxHeight: "clamp(100px, 30vh, 270px)",
    heroFlexGrow: true,
    bodyScrollable: false,
  },
};
